import "/app/lib/pn/form.css?transform-only";export default "__VITE_CSS_URL__2f6170702f6c69622f706e2f666f726d2e6373733f7472616e73666f726d2d6f6e6c79__"